import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Retails = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner1">
        <div className="banner-overlay1"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Retail</h6>
          <hr />
          <h1 className="banner-title">
            Transform Retail with <br /> Advanced Analytics and Solutions
          </h1>

          <p>
            Leverage data-driven insights to optimize your retail operations and
            enhance customer experiences.
          </p>

          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>

        {/* Add the image element */}
        <img
          className="banner-image"
          src="https://img.freepik.com/free-photo/girls-watching-display-store_23-2147669962.jpg"
          alt="Retail Analytics Solutions"
        />
      </section>

      <section id="about" className="about py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h6 className="col_yell">Retail</h6>
              <h2 className="">
                Innovative Retail Solutions for a Smarter Future
              </h2>
              <p className="">
                In the rapidly evolving retail landscape, we help businesses
                integrate data solutions that improve inventory management,
                optimize customer experiences, and enhance overall operational
                efficiency. Our advanced analytics enable retailers to predict
                trends, enhance sales strategies, and personalize customer
                interactions for sustainable growth and profitability.
              </p>
            </div>

            <div className="col-md-6">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="https://img.freepik.com/free-photo/beautiful-family-standing-cash-counter_171337-2410.jpg"
                        className="w-100"
                        alt="Empowering Decisions"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />

      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-12">
            <div className="serv_h1l mb-4">
              <h2 className="text-center">Retail Solutions</h2>
              <p className="text-center mb-0">
                Harness the power of data analytics to enhance customer
                experiences, improve retail performance, and boost
                profitability.
              </p>
            </div>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Customer Segmentation</a>
              </h3>
              <p className="mb-4">
                Understand customer behavior and segment your audience for
                personalized marketing and enhanced customer satisfaction.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Sales Forecasting</a>
              </h3>
              <p className="mb-4">
                Use predictive analytics to forecast sales trends and optimize
                stock levels, reducing waste and improving profitability.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Inventory Optimization</a>
              </h3>
              <p className="mb-4">
                Monitor and manage inventory in real-time to ensure availability
                while minimizing excess stock, enhancing supply chain
                efficiency.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Personalized Shopping Experience</a>
              </h3>
              <p className="mb-4">
                Create a tailored shopping experience for customers by
                leveraging behavioral insights and targeted promotions.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Pricing Optimization</a>
              </h3>
              <p className="mb-4">
                Implement dynamic pricing strategies to maximize revenue while
                staying competitive in the market.
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="p-4 border rounded bg-white card-hover">
              <h3 className="mb-3 card-title">
                <a href="#">Real-Time Analytics</a>
              </h3>
              <p className="mb-4">
                Monitor in-store and online performance in real-time to make
                immediate adjustments and optimize sales strategies.
              </p>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4 bg-black text-white">
            <div className="col-md-8">
              <div className="serv_h3l">
                <h2 className="">
                  Ready to Revolutionize Your Retail Business?
                </h2>
                <p className="mt-3">
                  Explore how our data-driven retail solutions can streamline
                  your operations, enhance customer experiences, and fuel
                  growth.
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/medium-shot-two-colleagues-discussing-business-office_1098-17855.jpg"
                        className="w-100"
                        alt="Retail Consultation"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Retails;
